import { motion } from "framer-motion";
import { PAIN_POINTS } from "../lib/data";

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.04, delayChildren: 0 } },
};
const itemVariants = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: [0.16, 1, 0.3, 1] } },
};

export default function PainPoints() {
  return (
    <section id="problems" data-testid="painpoints-section" className="px-6 md:px-12 py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-14 md:mb-20">
          <div className="overline mb-5" data-testid="painpoints-overline">Sound familiar?</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] leading-[1.05] tracking-tight text-strong font-medium">
            Nine quiet problems <span className="serif-italic text-accent">every chip team</span> lives with.
          </h2>
          <p className="mt-6 text-base md:text-lg text-muted leading-relaxed">
            None of these is a tooling problem. They're execution problems — and they compound.
          </p>
        </div>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.1 }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
        >
          {PAIN_POINTS.map((p, i) => (
            <motion.article 
              key={p.id} 
              variants={itemVariants}
              className="tile-card flex flex-col" 
              data-testid={`tile-${p.id}`}
            >
              <div className="text-[0.72rem] tracking-[0.22em] uppercase text-accent font-semibold mb-5">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-display text-2xl md:text-[1.6rem] leading-snug text-strong font-medium mb-4">{p.title}</h3>
              <p className="text-[15px] leading-relaxed text-muted mb-8">{p.body}</p>
              <a href="#contact" data-testid={`tile-cta-${p.id}`} className="link-arrow text-sm mt-auto">
                {p.cta} <span aria-hidden>→</span>
              </a>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
